// extracted by mini-css-extract-plugin
module.exports = {"headingWrapper":"authenticationTiltes_headingWrapper__1eAAU","header":"authenticationTiltes_header__2VYvo","subtitle":"authenticationTiltes_subtitle__3Ewyb"};